import { MapPin } from 'lucide-react';
import { useParams, useOutletContext, useNavigate } from 'react-router-dom';
import { useTranslations } from '../i18n';
import { theme, styles } from '../lib/theme';
import { Car } from '../lib/supabase';
import { LocationItem } from '../components/cars/LocationItem';
import { useLocations } from '../hooks/useCarData';

interface LocationsListProps {
    car: Car;
    isPublic?: boolean;
    highlightId?: string | null;
}

export function LocationsList({ car, highlightId }: LocationsListProps) {
    const { slug } = useParams();
    const outletContext = useOutletContext<any>() || {};
    const { t } = useTranslations();
    const navigate = useNavigate();
    const isAdminView = outletContext.isAdminView || false;
    const isPublic = outletContext.isReadOnly || false;
    const { data: rawLocations = [], isLoading: loading } = useLocations(car.id);
    const locations = (isPublic && !car.share_locations && !isAdminView) ? [] : rawLocations;

    console.log('LocationsList Debug:', { highlightId }); // Use highlightId

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center py-24 font-primary">
                <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mb-4" />
                <p className="text-gray-500 font-semibold italic">{t.common.loading}...</p>
            </div>
        );
    }

    return (
        <div className={`${theme.spacing.pagePadding} pb-32 pt-4 relative`}>
            {/* Locations List */}
            <div className="space-y-4">

                {locations.length === 0 ? (
                    <div className={`${styles.card} p-12 text-center shadow-sm`}>
                        <MapPin size={48} className="text-gray-200 dark:text-gray-600 mx-auto mb-4" />
                        <p className="text-gray-500 dark:text-gray-400 text-lg font-medium">{(t.locations as any)?.noLocations || 'No locations yet'}</p>
                    </div>
                ) : (
                    <div className="space-y-6">
                        <div className="space-y-3">
                            <div className={`${styles.card} shadow-sm divide-y ${theme.colors.divider}`}>
                                {locations.map(loc => (
                                    <LocationItem
                                        key={loc.id}
                                        location={loc}
                                        slug={slug}
                                        isAdminView={isAdminView}
                                        onClick={() => {
                                            const targetSlug = car?.slug || slug;
                                            const prefix = isAdminView ? '/admin' : '';
                                            navigate(`${prefix}/${targetSlug}/locations/${loc.id}`);
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
